import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-f4952e96"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tp-payment-container" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = {
  key: 0,
  class: "loader"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "loader-animation" }, " ", -1))
const _hoisted_5 = { class: "loader-text" }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "tp-payment-head" }
const _hoisted_8 = { class: "tp-payment-lang" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:{}" }, "EST", -1))
const _hoisted_10 = [
  _hoisted_9
]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:{}" }, "ENG", -1))
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:{}" }, "RUS", -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:{}" }, "LTU", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("a", { href: "javascript:{}" }, "LVA", -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = { class: "tp-payment-brand" }
const _hoisted_20 = ["src"]
const _hoisted_21 = {
  key: 0,
  class: "tp-payment-close"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "15px",
  height: "16px",
  viewBox: "0 0 15 16",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink"
}, [
  /*#__PURE__*/_createElementVNode("g", {
    id: "Page-1",
    stroke: "none",
    "stroke-width": "1",
    fill: "none",
    "fill-rule": "evenodd"
  }, [
    /*#__PURE__*/_createElementVNode("g", {
      id: "close",
      transform: "translate(-1.000000, 0.000000)",
      fill: "#123EDF",
      "fill-rule": "nonzero"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M10.0469,8 L14.875,3.21875 L15.8594,2.23438 C16,2.09375 16,1.85938 15.8594,1.67188 L14.8281,0.640625 C14.6406,0.5 14.4062,0.5 14.2656,0.640625 L8.5,6.45312 L2.6875,0.640625 C2.54688,0.5 2.3125,0.5 2.125,0.640625 L1.09375,1.67188 C0.953125,1.85938 0.953125,2.09375 1.09375,2.23438 L6.90625,8 L1.09375,13.8125 C0.953125,13.9531 0.953125,14.1875 1.09375,14.375 L2.125,15.4062 C2.3125,15.5469 2.54688,15.5469 2.6875,15.4062 L8.5,9.59375 L13.2812,14.4219 L14.2656,15.4062 C14.4062,15.5469 14.6406,15.5469 14.8281,15.4062 L15.8594,14.375 C16,14.1875 16,13.9531 15.8594,13.8125 L10.0469,8 Z",
        id: "Path"
      })
    ])
  ])
], -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = { key: 0 }
const _hoisted_25 = { class: "tp-payment-content" }
const _hoisted_26 = { class: "tp-table" }
const _hoisted_27 = { class: "tp-table-row" }
const _hoisted_28 = { class: "tp-table-col" }
const _hoisted_29 = { class: "tp-table-col" }
const _hoisted_30 = { class: "tp-table" }
const _hoisted_31 = { class: "tp-table-row" }
const _hoisted_32 = { class: "tp-table-col" }
const _hoisted_33 = { class: "tp-table-col" }
const _hoisted_34 = { class: "tp-table" }
const _hoisted_35 = { class: "tp-table-row" }
const _hoisted_36 = { class: "tp-table-col" }
const _hoisted_37 = { class: "tp-table-col" }
const _hoisted_38 = {
  key: 0,
  class: "tp-table"
}
const _hoisted_39 = { class: "tp-table-row" }
const _hoisted_40 = { class: "tp-table-col" }
const _hoisted_41 = { class: "tp-table-col" }
const _hoisted_42 = {
  key: 1,
  class: "tp-table"
}
const _hoisted_43 = { class: "tp-table-row" }
const _hoisted_44 = { class: "tp-table-col" }
const _hoisted_45 = { class: "tp-table-col" }
const _hoisted_46 = {
  key: 2,
  class: "tp-table"
}
const _hoisted_47 = { class: "tp-table-row" }
const _hoisted_48 = { class: "tp-table-col" }
const _hoisted_49 = { class: "tp-table-col" }
const _hoisted_50 = {
  key: 3,
  class: "tp-table"
}
const _hoisted_51 = { class: "tp-table-row" }
const _hoisted_52 = { class: "tp-table-col" }
const _hoisted_53 = { class: "tp-table-col" }
const _hoisted_54 = {
  key: 2,
  style: {"width":"100%"}
}
const _hoisted_55 = { class: "tp-payment-label" }
const _hoisted_56 = ["id", "value"]
const _hoisted_57 = {
  key: 1,
  class: "payment-error"
}
const _hoisted_58 = {
  key: 2,
  class: "tp-payment-links"
}
const _hoisted_59 = ["id", "href"]
const _hoisted_60 = ["alt", "src"]
const _hoisted_61 = {
  key: 3,
  class: "payment-error"
}
const _hoisted_62 = { key: 3 }
const _hoisted_63 = { class: "tp-payment-label" }
const _hoisted_64 = {
  key: 0,
  class: "payment-error"
}
const _hoisted_65 = { key: 1 }
const _hoisted_66 = { key: 0 }
const _hoisted_67 = ["value"]
const _hoisted_68 = { key: 0 }
const _hoisted_69 = { style: {"width":"100%","display":"flex","justify-content":"center"} }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 4,
  style: {"display":"flex","justify-content":"center","flex-direction":"column","text-align":"center"}
}
const _hoisted_72 = {
  key: 0,
  style: {"color":"red","font-size":"smaller","text-align":"center"}
}
const _hoisted_73 = { key: 1 }
const _hoisted_74 = { key: 2 }
const _hoisted_75 = {
  key: 5,
  style: {"display":"flex","justify-content":"center","flex-direction":"column","text-align":"center"}
}
const _hoisted_76 = { key: 0 }
const _hoisted_77 = { key: 1 }
const _hoisted_78 = { key: 1 }
const _hoisted_79 = { style: {"flex-direction":"row","display":"flex","margin-top":"40px","line-height":"2","font-size":"18px"} }
const _hoisted_80 = { style: {"width":"100%","display":"flex","flex-direction":"row","justify-content":"center","color":"red","font-weight":"bolder","font-size":"small"} }
const _hoisted_81 = { class: "tp-payment-terms" }
const _hoisted_82 = ["href"]
const _hoisted_83 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tp-payment-bg" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_swedbank_main = _resolveComponent("swedbank-main")!
  const _component_lhv_main = _resolveComponent("lhv-main")!

  return ((_ctx.is_modal && _ctx.modal_open) || !_ctx.is_modal)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass({ 'tp-payment': true, 'tp-payment-embed': !_ctx.is_modal, 'tp-payment-modal': _ctx.is_modal }),
        style: _normalizeStyle({
                '--backgroundColor': _ctx.colors.backgroundColor,
                '--bodyBackgroundColor': _ctx.colors.bodyBackgroundColor,
                '--borderColor': _ctx.colors.borderColor,
                '--headerAndFooterBackgroundColor': _ctx.colors.headerAndFooterBackgroundColor,
                '--headerTextColor': _ctx.colors.headerTextColor,
                '--bodyTextColor': _ctx.colors.bodyTextColor,
                '--footerTextColor': _ctx.colors.footerTextColor,
                '--selectTextColor': _ctx.colors.selectTextColor,
                '--hoveredBankBorderColor': _ctx.colors.hoveredBankBorderColor})
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_ctx.modal_open)
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (_ctx.show_loading)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _hoisted_4,
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.step && _ctx.step === 'wait-for-status' ? `${_ctx.getWaitingForConfirmationTxt()}` : _ctx.t("Loading")) + "...", 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createElementVNode("div", _hoisted_7, [
                        _createElementVNode("ul", _hoisted_8, [
                          _createElementVNode("li", {
                            class: _normalizeClass({ active: _ctx.locale_code === 'et_EE' }),
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.switchLang('et_EE')))
                          }, _hoisted_10, 2),
                          _createElementVNode("li", {
                            class: _normalizeClass({ active: _ctx.locale_code === 'en_GB' }),
                            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.switchLang('en_GB')))
                          }, _hoisted_12, 2),
                          _createElementVNode("li", {
                            class: _normalizeClass({ active: _ctx.locale_code === 'ru_RU' }),
                            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.switchLang('ru_RU')))
                          }, _hoisted_14, 2),
                          _createElementVNode("li", {
                            class: _normalizeClass({ active: _ctx.locale_code === 'lt_LT' }),
                            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.switchLang('lt_LT')))
                          }, _hoisted_16, 2),
                          _createElementVNode("li", {
                            class: _normalizeClass({ active: _ctx.locale_code === 'lv_LV' }),
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.switchLang('lv_LV')))
                          }, _hoisted_18, 2)
                        ]),
                        _createElementVNode("div", _hoisted_19, [
                          _createElementVNode("label", null, _toDisplayString(_ctx.t("Payment service provided by")), 1),
                          _createElementVNode("img", {
                            src: _ctx.assets_url + '/img/tarkpay-logo.png'
                          }, null, 8, _hoisted_20)
                        ]),
                        (_ctx.is_modal)
                          ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
                              _createElementVNode("a", {
                                href: "javascript:{}",
                                onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.closeThisModal && _ctx.closeThisModal(...args)))
                              }, _hoisted_23)
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      (!_ctx.show_error)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                            _createElementVNode("div", _hoisted_25, [
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createElementVNode("div", _hoisted_28, _toDisplayString(_ctx.t("Recipient name")), 1),
                                  _createElementVNode("div", _hoisted_29, _toDisplayString(_ctx.payment ? _ctx.payment.recipient_name : "-"), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_30, [
                                _createElementVNode("div", _hoisted_31, [
                                  _createElementVNode("div", _hoisted_32, _toDisplayString(_ctx.t("Amount")), 1),
                                  _createElementVNode("div", _hoisted_33, _toDisplayString(_ctx.payment ? parseFloat(_ctx.payment.amount).toFixed(2) : "-") + " EUR ", 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_34, [
                                _createElementVNode("div", _hoisted_35, [
                                  _createElementVNode("div", _hoisted_36, _toDisplayString(_ctx.t("Description")), 1),
                                  _createElementVNode("div", _hoisted_37, _toDisplayString(_ctx.payment ? _ctx.payment.description : "-"), 1)
                                ])
                              ]),
                              (_ctx.payment && _ctx.payment.reference_number)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                    _createElementVNode("div", _hoisted_39, [
                                      _createElementVNode("div", _hoisted_40, _toDisplayString(_ctx.t("Reference nr")), 1),
                                      _createElementVNode("div", _hoisted_41, _toDisplayString(_ctx.payment.reference_number), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.payment && _ctx.payment.frequency)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                    _createElementVNode("div", _hoisted_43, [
                                      _createElementVNode("div", _hoisted_44, _toDisplayString(_ctx.t("Frequency")), 1),
                                      _createElementVNode("div", _hoisted_45, _toDisplayString(_ctx.t(_ctx.payment.frequency)), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.payment && _ctx.payment.start_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                    _createElementVNode("div", _hoisted_47, [
                                      _createElementVNode("div", _hoisted_48, _toDisplayString(_ctx.t("Start date")), 1),
                                      _createElementVNode("div", _hoisted_49, _toDisplayString(_ctx.payment.start_date), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              (_ctx.payment && _ctx.payment.end_date)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_50, [
                                    _createElementVNode("div", _hoisted_51, [
                                      _createElementVNode("div", _hoisted_52, _toDisplayString(_ctx.t("End date")), 1),
                                      _createElementVNode("div", _hoisted_53, _toDisplayString(_ctx.payment.end_date), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]),
                            _createElementVNode("div", {
                              class: _normalizeClass(["tp-payment-foot", {'tp-payment-foot-swedbank': _ctx.swedbankEmbeded, 'tp-payment-foot-lhv': _ctx.lhvEmbeded}])
                            }, [
                              (_ctx.swedbankEmbeded)
                                ? (_openBlock(), _createBlock(_component_swedbank_main, {
                                    key: 0,
                                    class: "tp-payment-bank-layout",
                                    "is-bulk-payment": false,
                                    "active-bank": _ctx.bank_swift,
                                    "client-country": _ctx.locale_code || _ctx.payment.locale,
                                    payment: _ctx.payment,
                                    onResetFlow: _ctx.resetEmbedFlow,
                                    onDone: _ctx.embedBankDone
                                  }, null, 8, ["active-bank", "client-country", "payment", "onResetFlow", "onDone"]))
                                : (_ctx.lhvEmbeded)
                                  ? (_openBlock(), _createBlock(_component_lhv_main, {
                                      key: 1,
                                      class: "tp-payment-bank-layout",
                                      "is-bulk-payment": false,
                                      "active-bank": _ctx.bank_swift,
                                      "client-country": _ctx.locale_code || _ctx.payment.locale,
                                      payment: _ctx.payment,
                                      onResetFlow: _ctx.resetEmbedFlow,
                                      onDone: _ctx.embedBankDone
                                    }, null, 8, ["active-bank", "client-country", "payment", "onResetFlow", "onDone"]))
                                  : (!_ctx.show_accounts && !_ctx.show_status && !_ctx.show_n26)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.t("Choose a bank for payment")), 1),
                                        (Object.keys(_ctx.redirect_banks_by_country).length > 1)
                                          ? (_openBlock(), _createElementBlock("select", {
                                              key: 0,
                                              id: "countrySelect",
                                              onChange: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.changeCountry && _ctx.changeCountry(...args))),
                                              class: "form-select",
                                              style: {"width":"100%"}
                                            }, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Object.keys(_ctx.redirect_banks_by_country), (country) => {
                                                return (_openBlock(), _createElementBlock("option", {
                                                  key: country,
                                                  id: country,
                                                  value: country
                                                }, _toDisplayString(_ctx.getCountryName(country)), 9, _hoisted_56))
                                              }), 128))
                                            ], 32))
                                          : _createCommentVNode("", true),
                                        (_ctx.payment.error)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_57, _toDisplayString(_ctx.t(_ctx.payment.error)), 1))
                                          : _createCommentVNode("", true),
                                        (Object.keys(_ctx.redirect_banks_by_country).length > 0 && _ctx.redirect_banks_by_country[_ctx.default_country].length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.redirect_banks_by_country[_ctx.default_country], (b) => {
                                                return (_openBlock(), _createElementBlock("a", {
                                                  key: b,
                                                  id: b,
                                                  class: _normalizeClass('bank-link-' + b),
                                                  href: `${_ctx.api_url}/app/psd2/payment/${_ctx.payment_id}/${b}?locale=${_ctx.locale_code}&country=${_ctx.default_country}`
                                                }, [
                                                  _createElementVNode("img", {
                                                    alt: b + '_logo',
                                                    src: _ctx.assets_url + '/img/banks/' + b + '.svg'
                                                  }, null, 8, _hoisted_60)
                                                ], 10, _hoisted_59))
                                              }), 128))
                                            ]))
                                          : (_openBlock(), _createElementBlock("div", _hoisted_61, _toDisplayString("Service is currently unavailable."), 1))
                                      ]))
                                    : (_ctx.show_accounts)
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_62, [
                                          _createElementVNode("div", _hoisted_63, _toDisplayString(_ctx.t("Choose an account")), 1),
                                          (_ctx.payment.error)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_64, _toDisplayString(_ctx.t(_ctx.payment.error)), 1))
                                            : _createCommentVNode("", true),
                                          (_ctx.selected_name)
                                            ? (_openBlock(), _createElementBlock("p", _hoisted_65, [
                                                _createTextVNode(_toDisplayString(_ctx.strings.name) + ": " + _toDisplayString(_ctx.selected_name) + " ", 1),
                                                (_ctx.selected_currency)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_66, "(" + _toDisplayString(_ctx.selected_currency) + ")", 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            : _createCommentVNode("", true),
                                          _withDirectives(_createElementVNode("select", {
                                            id: "account-selector",
                                            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.selected_iban) = $event)),
                                            class: "form-select"
                                          }, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.payment.accounts, (account, idx) => {
                                              return (_openBlock(), _createElementBlock("option", {
                                                key: 'iban_' + idx,
                                                value: account.iban
                                              }, [
                                                _createTextVNode(_toDisplayString(account.iban), 1),
                                                (account.name)
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_68, _toDisplayString(" - " + account.name), 1))
                                                  : _createCommentVNode("", true)
                                              ], 8, _hoisted_67))
                                            }), 128))
                                          ], 512), [
                                            [_vModelSelect, _ctx.selected_iban]
                                          ]),
                                          _createElementVNode("div", _hoisted_69, [
                                            _createElementVNode("button", {
                                              id: "pay-button",
                                              class: _normalizeClass([{
                                            swedbankButtonColor: _ctx.swedbankSwifts.includes(_ctx.bank_swift),
                                            sebButtonColor: _ctx.sebSwifts.includes(_ctx.bank_swift),
                                            lhvButtonColor: _ctx.lhvSwifts.includes(_ctx.bank_swift),
                                            coopButtonColor: _ctx.coopSwifts.includes(_ctx.bank_swift),
                                            luminorButtonColor: _ctx.luminorSwifts.includes(_ctx.bank_swift)
                                        }, "button-redirect"]),
                                              disabled: !_ctx.selected_iban,
                                              type: "button",
                                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.userClickedPayButton && _ctx.userClickedPayButton(...args)))
                                            }, _toDisplayString(_ctx.t("Confirm the payment")), 11, _hoisted_70)
                                          ])
                                        ]))
                                      : (_ctx.show_status)
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_71, [
                                            (_ctx.payment.error)
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_72, _toDisplayString(_ctx.t(_ctx.payment.error)), 1))
                                              : _createCommentVNode("", true),
                                            (_ctx.step === 'finished')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_73, _toDisplayString(_ctx.t("Your payment was successful")), 1))
                                              : _createCommentVNode("", true),
                                            (_ctx.step === 'finished')
                                              ? (_openBlock(), _createElementBlock("p", _hoisted_74, _toDisplayString(_ctx.t("Thank you for the payment, you can now close this window")) + ". ", 1))
                                              : _createCommentVNode("", true)
                                          ]))
                                        : (_ctx.show_n26)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_75, [
                                              (_ctx.step === 'wait-for-n26-payment-confirmation')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_76, _toDisplayString(_ctx.t("Please go to your N26 Application and confirm payment")) + ". ", 1))
                                                : _createCommentVNode("", true),
                                              (_ctx.step === 'wait-for-n26-consent-confirmation')
                                                ? (_openBlock(), _createElementBlock("p", _hoisted_77, _toDisplayString(_ctx.t("Please go to your N26 Application and confirm consent to access accounts list")) + ". ", 1))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : _createCommentVNode("", true)
                            ], 2)
                          ]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_78, [
                            _createElementVNode("div", _hoisted_79, [
                              _createElementVNode("div", _hoisted_80, _toDisplayString(_ctx.t("Something went wrong. Please try again")), 1)
                            ])
                          ]))
                    ]))
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_81, [
          _createElementVNode("a", {
            href: `${_ctx.site_url}/public/kasutustingimused/`,
            target: "_blank"
          }, _toDisplayString(`Tarkpay ${_ctx.t("terms of use")}`), 9, _hoisted_82)
        ]),
        _hoisted_83
      ], 6))
    : _createCommentVNode("", true)
}